import React from 'react';

import { useBaseTable } from 'hooks/useBaseTable';

import { ReportList } from 'api/endPoints/getReportList';

import NoData from 'components/common/NoData/noData';
import { TableV8 } from 'components/common/Tables/TableV8/tableV8';

import { TableLocalFilters } from 'components/widgets/ChangeAnalysisTrackedActivities/tableLocalFilters/tableLocalFilters';
import { ReportsEmptyState } from 'components/widgets/ReportsHome/ReportsListTable/ReportsEmptyState';
import { useReportsTableProvider } from 'components/widgets/ReportsHome/ReportsListTable/ReportsListTable.Provider';
import classes from 'components/widgets/ReportsHome/ReportsListTable/ReportsListTable.module.scss';
import { columnsV8, initialState } from 'components/widgets/ReportsHome/ReportsListTable/ReportsListTable.utils';
import { ReportListTableFilter } from 'components/widgets/ReportsHome/ReportsListTable/filters/ReportListTableFilter';
import LayoutLeftRight from 'components/widgets/ReportsHome/genericLayouts/layoutLeftRight';
import Left from 'components/widgets/ReportsHome/genericLayouts/left';

const componentKey = 'reportsPortfolio';

export const ReportsListTable = () => {
    const { table } = useBaseTable({
        widgetId: undefined,
        localFilters: {},
        componentKey,
        initialState,
        columns: columnsV8,
    });
    const { api } = useReportsTableProvider();

    // Check if filters are active
    const hasActiveFilters = table.columnFilters.length > 0;

    // Check if user has no reports
    const hasNoReports =
        !api.getReportList.isLoading && (!api.getReportList.data || api.getReportList.data.length === 0);

    // Show full empty state if no reports and no filters
    if (hasNoReports && !hasActiveFilters) {
        return <ReportsEmptyState />;
    }

    return (
        <div className={classes.reportsListTableWrapper}>
            <TableLocalFilters>
                <LayoutLeftRight>
                    <Left>
                        <ReportListTableFilter table={table} api={api} />
                    </Left>
                </LayoutLeftRight>
            </TableLocalFilters>
            <div className={classes.tableContainer}>
                {table.updatedInitialState && (
                    <TableV8<ReportList>
                        data={api.getReportList.data ?? []}
                        columns={columnsV8}
                        maxHeight={1000}
                        isLoading={api.getReportList.isFetching}
                        noData={<NoData>No reports match the applied filter</NoData>}
                        sorting={table.sorting}
                        setSorting={table.setSorting}
                        columnVisibility={table.columnVisibility}
                        setColumnVisibility={table.setColumnVisibility}
                        columnOrder={table.columnOrder}
                        columnFilters={table.columnFilters}
                        setColumnOrder={table.setColumnOrder}
                        rowSelection={table.rowSelection}
                        setRowSelection={table.setRowSelection}
                        manualSorting={false}
                        manualFiltering={false}
                        tableClassName={classes.table}
                    />
                )}
            </div>
        </div>
    );
};
